import { useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import BulkActionsTable from "views/merchandise/tables/BulkActionsTable";
import { useAppSelector } from "redux/hooks";
import { buildTextColumn } from "views/merchandise/columns/buildTextColumn";
import getObjectValues from "utils/getObjectValues";
import { groupByProfileName } from "./useAmazonProfiles";
import { css } from "../../../../styled-system/css";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

const AgencyManagementTable = ({
  tableData = [],
  columnsToRender,
  isLoading,
  additionalColumns = [],
  bulkActionOptions = [],
  isSelectable = false,
  defaultSorted,
}) => {
  const [expandedAgency, setExpandedAgency] = useState(null);

  const marketPlace = useAppSelector((state) => state.marketPlace);
  const tableRef = useRef();

  const columnOptions = [
    buildTextColumn("acl", "Accounts", {
      formatter: (v) => v.join(", "),
    }),
    {
      key: "profiles",
      compareKey: null,
      options: {
        className: "text-start justify-content-start px-5 h-100",
        cellContainerClasses: "text-start justify-content-start",
        metric: {
          id: "orgs",
          format: "text",
          accessor: (d) => d,
          name: "Organizations & Profiles",
        },
        formatter: (row) => {
          const isExpanded = expandedAgency === row.id;

          const profiles = groupByProfileName(
            row.account_managers?.map((am) => am.global_amazon_profile_ids).flat(),
          )?.sort((a, b) => {
            return b?.accountInfo?.name - a?.accountInfo?.name;
          });

          const visibleProfiles = isExpanded ? profiles : profiles.slice(0, 3);

          return (
            <>
              <ul className="my-2">
                {visibleProfiles.map((profile, i) => {
                  const {
                    accountInfo: { name, type },
                    marketPlaces,
                  } = profile;

                  return (
                    <li className="py-1" key={`${name}-${type}-${i}`}>
                      {name} ({type}): {[...new Set(marketPlaces)].join(", ")}
                    </li>
                  );
                })}
              </ul>

              {profiles.length > 3 ?
                <span
                  className={css({ paddingLeft: "medium", fontSize: "small", cursor: "pointer" })}
                  onClick={() => (isExpanded ? setExpandedAgency(false) : setExpandedAgency(row.id))}
                >
                  View {isExpanded ? "Less" : "More"} Profiles{" "}
                  {isExpanded ?
                    <FaArrowUp />
                  : <FaArrowDown />}{" "}
                </span>
              : null}
            </>
          );
        },
        hideFilter: true,
      },
    },
    ...additionalColumns,
  ];

  const columnSpecs = columnsToRender.map((renderColumnKey) =>
    columnOptions.find((option) => option.key === renderColumnKey),
  );

  return (
    <Row className="mx-0 w-100">
      <Col xs={12} className="mx-auto px-0">
        <BulkActionsTable
          marketPlace={marketPlace}
          tableRef={tableRef}
          tableId={"agencyManagementTable"}
          titleCol={{
            id: "name",
            isStatic: true,
            Header: "Name",
            accessor: "name",
            style: { width: "450px" },
            width: 300,
            Cell: ({ value }) => {
              return <div className="d-flex align-items-start overflow-ellipsis">{value}</div>;
            },
            filterMethod: () => {
              return;
            },
            Filter: () => null,
          }}
          columnSpecs={columnSpecs}
          data={tableData}
          bulkActionOptions={bulkActionOptions}
          hideFilterToggleIcon={true}
          isSelectable={isSelectable}
          isExpandable={false}
          selectionKey={"id"}
          defaultSorted={defaultSorted || [{ id: "id", desc: true }]}
          getSearchCriteria={(row) => {
            return `${getObjectValues(row)}`;
          }}
          tableRowDescription={"Agency"}
          minRows={0}
          isLoading={isLoading}
          defaultPageSize={5}
        />
      </Col>
    </Row>
  );
};

export default AgencyManagementTable;
